import React from 'react'
import { Box, Paper, Typography, useMediaQuery, useTheme } from '@mui/material'
import { RfidCardExpirationChip } from './RfidCardExpirationChip'
import { I1Electriccar } from '@e3dc-react/icons'

interface RfidCardProps {
  name: string
  badgeId: string
  /** ISO date string */
  expirationDate: string | null | undefined
}

/** Card component used as a preview for the RFIDCard in the EditBadgeDialog */
export const RfidCardPreview: React.FC<RfidCardProps> = ({ badgeId, name, expirationDate }) => {
  const theme = useTheme()
  const downSm = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Paper
      sx={{
        overflow: 'hidden',
        backgroundColor: theme => theme.palette.grey[100],
        borderRadius: '16px',
        width: downSm ? '250px' : '300px',
        height: downSm ? '130px' : '160px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <I1Electriccar sx={{ width: '60px', height: '60px', mt: '12px', color: 'primary.main' }} />

        <Typography variant="body1" sx={{ textAlign: 'center', flex: 1, fontWeight: 'bold', wordBreak: 'break-word' }}>
          {name.trim()}
        </Typography>
      </Box>

      <Box sx={{ pl: 0.5 }}>
        <Typography variant="subtitle1" sx={{ fontSize: 12, whiteSpace: 'nowrap', py: downSm ? 1.5 : 3.5, px: downSm ? 0 : 0.5 }}>
          {badgeId ? `ID: ${badgeId}` : <EmptyText />}
        </Typography>

        <RfidCardExpirationChip expirationDate={expirationDate} />
      </Box>
    </Paper>
  )
}

export const EmptyText = (): JSX.Element => <>&#8288;</>
